import { UPDATE_USER_PERMISSIONS} from "../actionTypes";
import { editUserPermissions } from "../../../api/userManagement/updatePermissions.service";

const request = () => ({ type: UPDATE_USER_PERMISSIONS.REQUEST });
const failure = (error) => ({ type: UPDATE_USER_PERMISSIONS.FAILURE, error });
const success = (data) => ({ type: UPDATE_USER_PERMISSIONS.SUCCESS,data});



export const updateUserPermissions= (payload,id) => {
  return (dispatch, getState) => {
    dispatch(request());
    return editUserPermissions(payload,id)
      .then((res) => {
        dispatch(success(res));
        return Promise.resolve({res:res,status:true});
      })
      .catch((error) => {
        dispatch(failure(error?.message));
        return Promise.resolve({error:error?.message,status:false});
      });
  };
};
